export const DashboardEmptyField = ({ message }: { message: string }) => {
  return (
    <div className="flex flex-col md:flex-row items-left md:items-center p-10 border border-specialGray-012 cursor-pointer bg-specialGray-004 rounded-2xl to-white text-specialGray-075 justify-center">
      {message}
    </div>
  );
};
